export default {
  text: 'Deschide profilul {{paymentGateway}}',
  text_generic: 'Deschide profilul de onboarding',
  toasts: {
    failed_to_create: 'Deschiderea profilului {{paymentGateway}} a eșuat',
    link_copied: 'Link copiat în clipboard',
    copy_failed: 'Copierea link-ului a eșuat',
  },
};
